import { isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";

import { REQUEST } from "./tokens";
import { WINDOW } from "./window.service";

/**
 * this class is used to manage context of current application depends of SSR mode
 * -> locale (country/language) depend
 * -> mode (SSR or not)
 * -> Current path
 * -> ...
 */
@Injectable({ providedIn: "root" })
export class Context {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly request = inject(REQUEST, { optional: true });
    private readonly window = inject<Window>(WINDOW, { optional: true });

    public isInBrowserMode(): boolean {
        return isPlatformBrowser(this.platformId);
    }

    public isInServerMode(): boolean {
        return !isPlatformBrowser(this.platformId);
    }

    /**
     * Returns current path depends of rendering mode (SSR => Use Request, Browser => Use window.location)
     */
    public getCurrentHost(): string {
        if (this.isInBrowserMode()) {
            // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- WINDOW is guaranteed in browser mode
            return this.window!.location.host;
        }
        // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- REQUEST is guaranteed in SSR mode
        return this.request!.host;
    }

    /**
     * WARNING : Use ONLY with Angular full-pages
     * Returns current path depends of rendering mode (SSR => Use Request, Browser => Use window.location)
     */
    public getCurrentOrigin(): string {
        if (this.isInBrowserMode()) {
            // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- WINDOW is guaranteed in browser mode
            return this.window!.location.origin;
        }
        // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion -- REQUEST is guaranteed in SSR mode
        return this.request!.protocol + this.request!.hostname;
    }
}
